<template>
  <div>
    <v-tabs centered class="menuSettingsHeader" icons-and-text show-arrows background-color="transparent">
      <v-tabs-slider color="blue" />
      <v-tab to="/settings/users">
        {{ $t("settingsMenu.users") }}
        <v-icon>fa-users</v-icon>
      </v-tab>
      <v-tab to="/settings/cost-centre" v-if="$store.getters['userProperties'].system_settings.is_module_delegation_enabled === 2">
        {{ $t("settingsMenu.costCentre") }}
        <v-icon>fa-vote-yea</v-icon>
      </v-tab>
      <v-tab to="/settings/user-substitute" v-if="$store.getters['userProperties'].system_settings.is_module_delegation_enabled === 2">
        {{ $t("settingsMenu.userSubstitute") }}
        <v-icon>fa-users-cog</v-icon>
      </v-tab>
      <v-tab to="/settings/role">
        {{ $t("settingsMenu.role") }}
        <v-icon>fa-key</v-icon>
      </v-tab>
      <v-tab to="/settings/system-settings">
        {{ $t("settingsMenu.systemSettings") }}
        <v-icon>fa-database</v-icon>
      </v-tab>
      <v-tab to="/settings/workflow" v-if="$store.getters['userProperties'].system_settings.is_module_delegation_enabled === 2">
        {{ $t("settingsMenu.workflow") }}
        <v-icon>merge_type</v-icon>
      </v-tab>
      <v-tab to="/settings/delegation-rate" v-if="$store.getters['userProperties'].system_settings.is_module_delegation_enabled === 2">
        {{ $t("settingsMenu.delegationRate") }}
        <v-icon>fa-hand-holding-usd</v-icon>
      </v-tab>
      <v-tab to="/settings/custom-webpage" v-if="$store.getters['userProperties'].system_settings.is_module_delegation_enabled === 2">
        {{ $t("settingsMenu.customWebpage") }}
        <v-icon>view_agenda</v-icon>
      </v-tab>
      <v-tab
        to="/settings/delegation-task"
        v-if="
          $store.getters['userProperties'].system_settings.is_module_delegation_enabled === 2 &&
            $store.getters['userProperties'].system_settings.is_delegation_task_enabled === 2
        "
      >
        {{ $t("settingsMenu.delegationTaskEdit") }}
        <v-icon>assignment</v-icon>
      </v-tab>
      <v-tab to="/settings/vehicles" v-if="$store.getters['userProperties'].system_settings.is_module_delegation_enabled === 2">
        {{ $t("settingsMenu.vehicles") }}
        <v-icon>directions_car</v-icon>
      </v-tab>
      <v-tab to="/settings/organizational-structure" v-if="$store.getters['userProperties'].system_settings.is_module_delegation_enabled === 2">
        {{ $t("settingsMenu.organizationStructure") }}
        <v-icon>fa-sitemap</v-icon>
      </v-tab>
      <v-tab disabled to="/settings/exchange-rates" v-if="$store.getters['userProperties'].system_settings.is_module_delegation_enabled === 2">
        {{ $t("settingsMenu.exchangeRates") }}
        <v-icon>fa-dollar-sign</v-icon>
      </v-tab>
      <v-tab to="/settings/logs">
        {{ $t("settingsMenu.logs") }}
        <v-icon>fa-list-ol</v-icon>
      </v-tab>
      <v-tab to="/settings/travel-service" v-if="$store.getters['userProperties'].system_settings.is_module_travel_service_enabled === 2">
        {{ $t("settingsMenu.travelService") }}
        <v-icon>fa-globe</v-icon>
      </v-tab>
    </v-tabs>
    <router-view />
  </div>
</template>

<script>
export default {
  name: "SettingsMenuView",
  mounted() {
    this.$store.dispatch("Visual/setHalfMenuBackground");
  },
  computed: {
    isReInvoicingModuleEnabled() {
      return this.$store.getters["userProperties"].system_settings.re_invoicing_for_external_contractor_module === 2;
    }
  },
  beforeDestroy() {
    this.$store.dispatch("Visual/setWhiteBackground");
  }
};
</script>

<style>
.menuSettingsHeader {
  padding-bottom: 34px;
  margin-top: -25px;
}

.menuSettingsHeader > .v-tabs__bar {
  background: none;
}

.menuSettingsHeader .v-icon {
  font-size: 36px;
}

.menuSettingsHeader .v-tabs__item {
  font-weight: 700;
}
</style>
